import React, { Component } from 'react'
import { Dialog, DialogContent, DialogTitle, DialogActions, Button, Grid } from '@material-ui/core'
import { uploadAssetAPI } from '../../../api/assets'
import { EditableImageUploader } from '../../common/ImageUploader'
import {
  updateSingleMasterProducts,
} from '../../../actions/masterCatalog'
import { MASTER_PRODUCT, updateChildSource } from '../CommonUpdateCells'

const FIELD = 'assets'

class ModalMcImages extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productImages: this.props.data.assets,
      openViewImageModal: false,
      selectedImage: null,
    }
  }

  closeImageModal = () => {
    this.props.onClose && this.props.onClose()
  }

  uploadProductImage = (file, type, url) => {
    return new Promise((res, rej) => {
      uploadAssetAPI(file, 'photo/public').then((response) => {
        let newList = [...this.state.productImages]
        newList.push(response)
        this.handleChange(newList)
        res(response)
      })
    })
  }

  removeImage = (image) => {
    let newList = this.state.productImages.filter((c) => c.id !== image.id)
    this.handleChange(newList)
  }

  onUpdateProductCell = (source = 'PARENT') => {
    updateChildSource(MASTER_PRODUCT, this.props, FIELD, source)
  }

  handleChange = (updatedImages) => {
    const { data, setValue } = this.props
    let isParent = !!data.children
    setValue(updatedImages)

    if (isParent) {
      const newData = { ...data, assets: updatedImages }
      this.props.dispatch(updateSingleMasterProducts(newData))
    } else {
      if (data.masterId) {
        this.onUpdateProductCell('CHILD')
      }
    }
    this.setState({ productImages: updatedImages })
  }

  handleCloseViewImage = () => {
    this.setState({
      openViewImageModal: false,
    })
  }

  viewImage = (image) => {
    this.setState({
      selectedImage: image.largeX2URL,
      openViewImageModal: true,
    })
  }
  render() {
    const { open, data } = this.props
    const { productImages, openViewImageModal, selectedImage } = this.state
    return (
      <div>
        <Dialog open={open} className={'container-modal'} style={{ width: '640px' }}>
          <DialogTitle>Images</DialogTitle>
          <DialogContent className={'size-modal'} style={{ width: '640px' }}>
            <b>Product: </b>
            <span>{data.name}</span>
            <br></br>
            {data.shop && (
              <div>
                <b>Shop: </b>
                <span>{data.shop.name}</span>
              </div>
            )}
            <div className="align-title-and-button">
              <EditableImageUploader
                editMode={true}
                valueToRender={null}
                hideImage={true}
                imageUploadAPI={this.uploadProductImage}
              />
            </div>
            <div className="container-scroll-y">
              <Grid container className="container-product-image">
                {productImages.length > 0 ? (
                  productImages.map((image, index) => (
                    <Grid key={index} item className="align-item-product-image">
                      <img src={image.largeX2URL} className="product-image" />
                      <Grid className="container-delete-view">
                        <span
                          className="button-remove-image"
                          onClick={() => this.removeImage(image)}
                        >
                          DELETE
                        </span>

                        <span className="view-image-button" onClick={() => this.viewImage(image)}>
                          VIEW
                        </span>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <span>This product has no images</span>
                )}
              </Grid>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeImageModal}>Close</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openViewImageModal} className={'container-modal'}>
          <DialogContent>
            <img src={selectedImage} className="" />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseViewImage}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default ModalMcImages



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Modals/ModalMcImages.js